'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'ufo-beam';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e048';
var svgPathData = ['M32 224c0 25.5 22.6 53.5 70.5 76 46.7 22 112.2 36 185.5 36s138.9-14 185.5-36c47.9-22.5 70.5-50.5 70.5-76s-22.6-53.5-70.5-76c-8-3.8-16.6-7.3-25.7-10.6 .1 2.2 .1 4.4 .1 6.6l0 16c0 4.1-1.6 8-4.4 11-35.3 37.4-97 54.2-155.6 54.2S167.7 208.3 132.4 171c-2.8-3-4.4-6.9-4.4-11l0-16c0-2.2 0-4.4 .1-6.6-9.1 3.3-17.6 6.8-25.7 10.6-47.9 22.5-70.5 50.5-70.5 76zm112 16a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm168 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm168-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M160 144c0-70.7 57.3-128 128-128S416 73.3 416 144l0 9.3c-27.6 25.5-76.4 39.9-128 39.9s-100.4-14.3-128-39.9l0-9.3zm-31.9-6.6c-.1 2.2-.1 4.4-.1 6.6l0 16c0 4.1 1.6 8 4.4 11 35.3 37.4 97 54.2 155.6 54.2S408.3 208.3 443.6 171c2.8-3 4.4-6.9 4.4-11l0-16c0-2.2 0-4.4-.1-6.6 9.1 3.3 17.6 6.8 25.7 10.6 47.9 22.5 70.5 50.5 70.5 76s-22.6 53.5-70.5 76c-46.7 22-112.2 36-185.5 36s-138.9-14-185.5-36C54.6 277.5 32 249.5 32 224s22.6-53.5 70.5-76c8-3.8 16.6-7.3 25.7-10.6zm5.5-35.6c-16.1 5-31.1 10.8-44.8 17.2-50.5 23.8-88.9 59.8-88.9 105s38.3 81.2 88.9 105c51.8 24.4 122.2 39 199.1 39s147.4-14.6 199.1-39c50.5-23.8 88.9-59.8 88.9-105s-38.3-81.2-88.9-105C473.5 112.6 458.5 106.8 442.4 101.8 423.9 33.9 361.8-16 288-16S152.1 33.9 133.6 101.8zM312 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-192-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm360-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM145.1 394.8c-7.3-5-17.2-3.2-22.3 4l-72 104c-5 7.3-3.2 17.2 4 22.3s17.2 3.2 22.3-4l72-104c5-7.3 3.2-17.2-4-22.3zm281.7 22.3l72 104c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3l-72-104c-5-7.3-15-9.1-22.3-4s-9.1 15-4 22.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUfoBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;